/**
 * Starter clusters per `02-rules-spec.md` §3.7.
 *
 * Each player starts with a 3-tile upright triangle (△) placed at `(0,0)`
 * (top — single-habitat keystone), `(0,1)` (bottom-right / 5 o'clock —
 * dual-habitat) and `(-1,1)` (bottom-left / 7 o'clock — dual-habitat). The
 * two duals are mutually adjacent, so the cluster is a 3-clique with the
 * keystone on top. These are the 5 published starters; one is dealt at
 * random per player (§6.1.3). Tile data lives in `tile-defs.ts`
 * (`tile_startNN_{key,d5,d7}`); no wildlife is pre-placed.
 */

import type { AxialCoord } from "../types/coords";

export interface StartClusterTile {
  readonly tileDefId: string;
  readonly coord: AxialCoord;
}

export interface StartCluster {
  readonly id: string;
  readonly tiles: readonly [
    StartClusterTile,
    StartClusterTile,
    StartClusterTile,
  ];
}

export const START_CLUSTERS: readonly StartCluster[] = [
  {
    id: "starter_1",
    tiles: [
      { tileDefId: "tile_start01_key", coord: { q: 0, r: 0 } },
      { tileDefId: "tile_start01_d5", coord: { q: 0, r: 1 } },
      { tileDefId: "tile_start01_d7", coord: { q: -1, r: 1 } },
    ],
  },
  {
    id: "starter_2",
    tiles: [
      { tileDefId: "tile_start02_key", coord: { q: 0, r: 0 } },
      { tileDefId: "tile_start02_d5", coord: { q: 0, r: 1 } },
      { tileDefId: "tile_start02_d7", coord: { q: -1, r: 1 } },
    ],
  },
  {
    id: "starter_3",
    tiles: [
      { tileDefId: "tile_start03_key", coord: { q: 0, r: 0 } },
      { tileDefId: "tile_start03_d5", coord: { q: 0, r: 1 } },
      { tileDefId: "tile_start03_d7", coord: { q: -1, r: 1 } },
    ],
  },
  {
    id: "starter_4",
    tiles: [
      { tileDefId: "tile_start04_key", coord: { q: 0, r: 0 } },
      { tileDefId: "tile_start04_d5", coord: { q: 0, r: 1 } },
      { tileDefId: "tile_start04_d7", coord: { q: -1, r: 1 } },
    ],
  },
  {
    id: "starter_5",
    tiles: [
      { tileDefId: "tile_start05_key", coord: { q: 0, r: 0 } },
      { tileDefId: "tile_start05_d5", coord: { q: 0, r: 1 } },
      { tileDefId: "tile_start05_d7", coord: { q: -1, r: 1 } },
    ],
  },
];

export const START_CLUSTERS_BY_ID: Readonly<Record<string, StartCluster>> =
  Object.freeze(
    Object.fromEntries(START_CLUSTERS.map((cluster) => [cluster.id, cluster])),
  );
